
<!-- Hero Section -->
<section class="hero">
    <div class="hero-content">
        <h1>Welcome to Jar.games</h1>
        <p>The official hub for Jar's VRChat worlds and game development projects</p>
        <div class="v-flex" style="align-items: start;">
            <button mat-raised-button color="accent">Explore Worlds</button>
            <a mat-flat-button href="https://discord.gg/cult-of-jar" target="_blank">
                <mat-icon>discord</mat-icon>
                Join Discord
            </a>
        </div>
    </div>
    <img src="/img/hero.webp" alt="Jar Avatar" class="hero-image">
</section>

<!-- Features Introduction Section -->
<section class="features-section">
    <div class="features-container">

        <!-- Features Grid -->
        <div class="features-grid">

            <mat-card class="feature-card">
                <mat-card-header>
                    <mat-icon mat-card-avatar class="feature-icon">star</mat-icon>
                    <mat-card-title>Patreon Supporter Perks</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>Connect your Patreon account to unlock exclusive in-game benefits and supporter features across Jar's worlds.</p>
                    <ul>
                        <li>Access to exclusive in-game features</li>
                        <li>Special recognition and supporter roles</li>
                    </ul>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button [routerLink]="['/patreon']">Connect Patreon</button>
                </mat-card-actions>
            </mat-card>

            <mat-card class="feature-card">
                <mat-card-header>
                    <mat-icon mat-card-avatar class="feature-icon">person</mat-icon>
                    <mat-card-title>Manage Your Account</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>Connect your accounts and manage your profile across all of Jar's projects and platforms.</p>
                    <ul>
                        <li>Link your VRChat account for seamless integration</li>
                        <li>Connect Patreon for automatic perk activation</li>
                    </ul>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button [routerLink]="['/login']">Get Started</button>
                </mat-card-actions>
            </mat-card>
        </div>

        <!-- FAQ Section -->
        <mat-card class="faq-card">
            <mat-card-header>
                <mat-card-title>Frequently Asked Questions</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <br>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>How do I get my Patreon perks?</mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>Connect your Patreon and VRChat accounts at <a routerLink="/patreon">here</a> to unlock your in-game perks.</p>
                </mat-expansion-panel>

            </mat-card-content>
        </mat-card>
    </div>
</section>
